export default {
  // auth
  authLoginURL: '/cms/login',
  authRenewalURL: '/cms/refresh-token',

  alertsURL: '/cms/alerts/',

  clientsURL: '/cms/clients/',
  clientsExportExcelURL: '/cms/clients/export',
  clientsAthosExportExcelURL: '/cms/clients/export-athos',
  clientsExportDocumentsURL: '/cms/clients/export-documents',
  clientsSearchURL: '/cms/clients/search',
  clientsCurrentChecksURL: '/cms/clients/current-checks',
  clientsCurrentRevisionsURL: '/cms/clients/current-revisions',

  notesURL: '/notes/',
  documentsURL: '/documents/',
  documentDownloadURL: '/download',
  documentSendURL: '/send',
  documentPreviewURL: 'preview',
  documentsBaseURL: '/cms/documents/',
  documentsLastURL: '/cms/documents/last',
  documentsExportAccountancyDocumentsURL: '/cms/documents/export-accountancy',
  documentsPrintInvoiceURL: '/cms/documents/invoices/print',
  documentSearchURL: '/cms/documents/search',
  documentsExportAnreFilesURL: '/cms/documents/anre/export',
  documentsExportAnreExcelURL: '/cms/documents/anre/export-xls',
  documentsExportIscirURL: '/cms/documents/iscir/export',
  documentsExporConsumptionReceiptsURL: '/cms/documents/consumption-receipts/export',

  expensesURL: '/cms/expenses/',
  expensesByPaymentTypesURL: '/cms/expenses/payment-types/',
  cashRegisterExportExcelURL: '/cms/expenses/cash-register/export',
  cashRegisterUpdateProfitURL: '/cms/expenses/cash-register',
  vatReportExportExcelURL: '/cms/expenses/vat-report/export',

  invoicesURL: '/cms/documents/invoices',
  invoicesExportExcelURL: '/cms/documents/invoices/export',
  invoicesVTPExportExcelURL: '/cms/documents/invoices/export/vtp',
  invoicesExportOpisURL: '/cms/documents/invoices/export-opis',

  failuresURL: '/cms/failures/',

  usersURL: '/cms/users/',

  tasksURL: '/cms/tasks/',
  tasksSearchURL: '/cms/tasks/search',
  tasksLatestURL: (id) => `/cms/tasks/clients/${id}/latest`,

  productsURL: '/cms/products/',
  productSearchURL: '/cms/products/stocks/search',
  stocksURL: '/stocks/',
  exportStocksURL: '/cms/products/stocks/export',

  analyzersURL: '/cms/analyzers/',

  settingsURL: '/cms/settings/',
};
